import { render, staticRenderFns } from "./ZeroStockDialog.vue?vue&type=template&id=79225c71&scoped=true&"
import script from "./ZeroStockDialog.vue?vue&type=script&lang=js&"
export * from "./ZeroStockDialog.vue?vue&type=script&lang=js&"
import style0 from "./ZeroStockDialog.vue?vue&type=style&index=0&id=79225c71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79225c71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VIcon,VTextField})
